export const isThereDataToPresent = (data: any) => {
    const dataIsEmpty = !data || (Object.keys(data).length === 1 && data.files && data.files.length === 0);
    return !dataIsEmpty;
};
